import { Validator } from "@portal/kit/pkg/services"

export default function checkoutValidator(values){
  const rules = {
    email: ['isRequired', 'isEmail'],
    first_name: ['isRequired'],
    last_name: ['isRequired'],
    'address.street_1': ['isRequired'],
    'address.postcode': ['isRequired'],
    'address.city': ['isRequired'],
    'address.country': ['isRequired']
  }

  return new Validator(values, rules).getErrors()
}
